class Store {
    
    constructor(onUpdate) {
        this.zeme = [new Zeme(onUpdate)];
        this.loadedData = {};
        this.apiUrl = "https://www.studyline.cz/online-sluzby/prihlaska-ke-studiu/?test=1";
    }

    set setOnUpdate(fn) {
        for(let i = 0; i<this.zeme.length; i++) {
            this.zeme[i].onUpdate = fn;
        }
    }

    setLoadedData = (data) => {
        this.loadedData = data;
        let onUpdate = this.zeme[0].onUpdate;
        for(var key in data) {

            let value = data[key];

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[value\]/g;
            var result = re.exec(key);
            if(result) {
                this.zeme[result[1]].value = value;
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[value\]/g;
            var result = re.exec(key);
            if(result) {
                this.zeme[result[1]].mesta[result[2]].value = value;
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[skola\]\[([0-9]*)\]\[value\]/g;
            var result = re.exec(key);
            if(result) {
                this.zeme[result[1]].mesta[result[2]].skoly[result[3]].value = value;
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[skola\]\[([0-9]*)\]\[selectedJuniors\]/g;
            var result = re.exec(key);
            if(result) {
                this.zeme[result[1]].mesta[result[2]].skoly[result[3]].selectedJuniors = value.split(';');
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[skola\]\[([0-9]*)\]\[kurz\]\[([0-9]*)\]\[value\]/g;
            var result = re.exec(key);
            if(result) {
                let kurzy = this.zeme[result[1]].mesta[result[2]].skoly[result[3]].kurzy;
                if(!kurzy[result[4]]) {
                    kurzy[result[4]] = new Kurz(onUpdate);
                }
                kurzy[result[4]].value = value;
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[skola\]\[([0-9]*)\]\[kurz\]\[([0-9]*)\]\[delka\]/g;
            var result = re.exec(key);
            if(result) {
                let kurzy = this.zeme[result[1]].mesta[result[2]].skoly[result[3]].kurzy;
                if(!kurzy[result[4]]) {
                    kurzy[result[4]] = new Kurz(onUpdate);
                }
                kurzy[result[4]].delkaStudia.value = value;
            }

            var re = /prihlaska\[zeme\]\[([0-9]*)\]\[mesto\]\[([0-9]*)\]\[skola\]\[([0-9]*)\]\[kurz\]\[([0-9]*)\]\[nastup\]/g;
            var result = re.exec(key);
            if(result) {
                let kurzy = this.zeme[result[1]].mesta[result[2]].skoly[result[3]].kurzy;
                if(!kurzy[result[4]]) {
                    kurzy[result[4]] = new Kurz(onUpdate);
                }
                kurzy[result[4]].delkaStudia.nastup.value = value != "Invalid date" ? value : null;
            }
        }
    }

    vyplnenyPrvniKurz() {
        if(this.zeme[0].mesta[0].skoly[0].kurzy[0].delkaStudia.nastup.value !== "") {
            return true;
        } else {
            return false
        }
    }

    zvolenyJuniorKurz() {
        return this.zeme[0].mesta[0].skoly[0].selectedJuniors.length > 0;
    }
    prvniNastupniTerminKurzu = () => {
        let kurzy = this.zeme[0].mesta[0].skoly[0].kurzy;
        let termin = null;
        for(let i = 0; i < kurzy.length; i++) {
            let n = kurzy[i].delkaStudia.nastup.value;
            if(n !== "") {
                let d = new Date(n);
                if(!termin || d < new Date(termin) ) {
                    termin = n;
                }
            }
            
        }
        return termin;
    }

    nejvetsiDelkaStudia = () => {
        let kurzy = this.zeme[0].mesta[0].skoly[0].kurzy;
        let delka = 0;
        for(let i = 0; i < kurzy.length; i++) {
            let d = kurzy[i].delkaStudia.value;
            if(d > delka ) {
                delka = d;
            }
            
        }
        return delka;
    }

    delkaStudiaCelkem = () => {
        let nastup = new Date(this.prvniNastupniTerminKurzu());
        let kurzy = this.zeme[0].mesta[0].skoly[0].kurzy;

        let konec = 0;
        for(let i = 0; i < kurzy.length; i++) {
            let kurz = kurzy[i];
            let d = kurz.delkaStudia.value;
            let n = kurz.delkaStudia.nastup.value;
            if(d !== "" && n !== "") {
                let s = new Date(n);
                s.setDate(s.getDate() + parseInt(d));
                if(s > konec) {
                    konec = s;
                }
            }
            
        }
        if(konec > 0) {
            let delka = (konec - nastup)/1000/60/60/24;
            delka = Math.ceil(delka/7)*7; 
            return delka;
        } else {
            return 0;
        }
        
    }
}

class Zeme {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        this.mesta = [];
        this.addMesto();
        if(this.onUpdate) {
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

    addMesto() {
        let onUpdate = this.onUpdate;
        if(this.mesta[0] && this.mesta[0].onUpdate) {
            let onUpdate = this.mesta[0].onUpdate;
        }
        this.mesta.push(new Mesto(onUpdate));
    }

    set setOnUpdate(fn) {
        for(let i = 0; i<this.mesta.length; i++) {
            this.mesta[i].onUpdate = fn;
        }
    }
}

class Mesto {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        this.skoly = [];
        this.addSkola();
        if(this.onUpdate) {
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

    addSkola() {
        let onUpdate = this.onUpdate;
        if(this.skoly[0] && this.skoly[0].onUpdate) {
            let onUpdate = this.skoly[0].onUpdate;
        }
        this.skoly.push(new Skola(onUpdate));
    }

    set setOnUpdate(fn) {
        for(let i = 0; i<this.skoly.length; i++) {
            this.skoly[i].onUpdate = fn;
        }
    }
}

class Skola {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        this.kurzy = [];
        this.selectedJuniors = [];
        this.addKurz();
        if(this.onUpdate) {
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

    addKurz = () => {
        let onUpdate = this.onUpdate;
        if(this.kurzy[0] && this.kurzy[0].onUpdate) {
            let onUpdate = this.kurzy[0].onUpdate;
        } 
        this.kurzy.push(new Kurz(onUpdate));
    }

    set setOnUpdate(fn) {
        for(let i = 0; i<this.kurzy.length; i++) {
            this.kurzy[i].onUpdate = fn;
        }
    }
}

class Kurz {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        this.delkaStudia = new DelkaStudia(this.onUpdate);
        if(this.onUpdate) {
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

    set setOnUpdate(fn) {
        this.delkaStudia.onUpdate = fn
    }
}

class DelkaStudia {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        if(!this.nastup) {
            this.nastup = new Nastup(this.onUpdate);
        }
        if(this.onUpdate) {
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

    set setOnUpdate(fn) {
        this.nastup.onUpdate = fn
    }
}

class Nastup {
    constructor(onUpdate) {
        this.onUpdate = onUpdate;
        this.value = "";
    }

    set value(value) {
        this._value = value;
        if(this.onUpdate) {
            
            this.onUpdate();
        }
    }

    get value() {
        return this._value;
    }

}

export default Store;


// WEBPACK FOOTER //
// ./resources/prihlaska/store.js